export default __webpack_public_path__ + "static/media/CTP_Dark_FR.c156c16f.svg";